import React, { Component } from 'react';

import cn from 'classnames';
import * as dt from 'core/datetime';
import { DATE_FORMAT } from 'globals/constants';
import TinyDatePicker from 'tiny-date-picker';

interface Props {
  value?: Date;
  minDate?: Date;
  focusedDate?: Date;
  maxDate?: Date;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => any;
  onChange?: (date: Date) => void;
  dateFormat?: string;
  placeholder?: string;
}

interface State {
  dp: any;
  isOpen: boolean;
}

export default class DatePicker extends Component<Props, State> {
  hostElem: HTMLDivElement | null = null;

  state: State = {
    dp: null,
    isOpen: false,
  };

  init() {
    const { value, minDate, maxDate, focusedDate } = this.props;

    if (!this.hostElem) {
      console.error('host element not found!');
      return;
    }

    const dp = TinyDatePicker(this.hostElem, {
      min: minDate ? dt.startOfDay(minDate) : undefined,
      max: maxDate,
      hilightedDate: focusedDate ? focusedDate : value,
      mode: 'dp-modal',
      lang: {
        close: 'CANCEL',
      },
    });

    dp.setState({
      selectedDate: focusedDate ? focusedDate : value,
    });

    dp.on({
      open: this.onOpen,
      close: this.onClose,
      select: this.onSelect,
    });

    this.setState({ dp });
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps: Props) {
    const { dp } = this.state;
    if (!dp) return;

    if (prevProps.minDate !== this.props.minDate || prevProps.maxDate !== this.props.maxDate) {
      dp.destroy();
      this.init();
    }
  }

  componentWillUnmount() {
    const { dp } = this.state;
    if (!dp) return;

    // Remove all handlers of any event
    dp.off();
  }

  onOpen = () => {
    this.setState({ isOpen: true });
  };

  onClose = () => {
    this.setState({ isOpen: false });
  };

  onSelect = () => {
    const { dp } = this.state;
    const { onChange } = this.props;

    if (!dp || !onChange) return;

    onChange(dp.state.selectedDate);
    dp.close();
  };

  handleOnClick = () => {
    const { dp: instance, isOpen } = this.state;
    const { onClick = () => {} } = this.props;

    if (!instance) return;

    if (isOpen) {
      instance.close();
    } else {
      onClick();
      instance.open();
    }
  };

  public render() {
    const { value, style, className, children, placeholder = 'Select date' } = this.props;
    return (
      <div
        style={style}
        className={cn('datepicker', 'pointer', className, { datepicker__empty: !value })}
        ref={(el) => (this.hostElem = el)}
        onClick={this.handleOnClick}
      >
        {children ? children : value ? dt.format(value, DATE_FORMAT) : placeholder}
      </div>
    );
  }
}
